import React, { useEffect, useRef } from 'react';
import { Button } from '@fluentui/react-components';
import { QuestionCircle20Regular } from '@fluentui/react-icons';

import { I18nModel } from '@bingads-webui/copilot-i18n';

export interface IPopupController {
  PopupJsClick: (target: any) => void;
}

declare global {
  interface Window {
    PopupController?: IPopupController;
  }
}
export interface HelpPopupProps {
  i18n: I18nModel;
  topic: string;
  label?: string;
}

export const HelpPopup: React.FC<HelpPopupProps> = ({ i18n, label, topic }) => {
  const ref = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.setAttribute('type', 'helppopup');
      ref.current.setAttribute('topic', topic);
    }
  }, [topic]);

  return (
    <Button
      ref={ref}
      appearance="subtle"
      size="small"
      aria-label={label ?? i18n.getString(_TL_('Learn more'))}
      icon={<QuestionCircle20Regular />}
      onClick={(e) => {
        e.preventDefault();
        window.PopupController?.PopupJsClick(ref.current);
      }}
    />
  );
};
